"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedProxyGuestChatDecline =
/*#__PURE__*/
function (_pb_1$ProxyGuestChatD) {
  _inherits(ExtendedProxyGuestChatDecline, _pb_1$ProxyGuestChatD);

  function ExtendedProxyGuestChatDecline(properties) {
    var _this;

    _classCallCheck(this, ExtendedProxyGuestChatDecline);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedProxyGuestChatDecline).call(this, properties));
    _this.type = ExtendedProxyGuestChatDecline.type;
    _this.chreqid = properties.proxy.chreqid;
    return _this;
  }

  _createClass(ExtendedProxyGuestChatDecline, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.proxy.guest).concat(ExtendedProxyGuestChatDecline.context);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.ProxyGuestChatDecline.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedProxyGuestChatDecline(pb_1.ProxyGuestChatDecline.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedProxyGuestChatDecline;
}(pb_1.ProxyGuestChatDecline);

ExtendedProxyGuestChatDecline.type = "ProxyGuestChatDecline";
ExtendedProxyGuestChatDecline.context = "/guest-chat/cancel/decline";
exports.ProxyGuestChatDecline = ExtendedProxyGuestChatDecline;